/**
 * @generated SignedSource<<b29619aafc91b400ab56273db3ed11bb>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ActivityTypeEnum = "assignment" | "call" | "change" | "create_user" | "email" | "match" | "note" | "offer" | "origination" | "requalification" | "task" | "visit";
export type EmailVisibilityTypeEnum = "organisation" | "private" | "shared";
export type OfferStatus = "accepted" | "pending" | "refused";
export type ParticipantStatus = "maybe" | "no" | "noreply" | "yes";
export type UpsertActivityInput = {
  activity: ActivityInput;
  clientMutationId?: string | null;
  notifyParticipants?: boolean | null;
};
export type ActivityInput = {
  activityType?: ActivityTypeEnum | null;
  assignedTo?: string | null;
  createdBy?: string | null;
  done?: boolean | null;
  doneAt?: string | null;
  dueAt?: string | null;
  endAt?: string | null;
  endDate?: string | null;
  id?: string | null;
  location?: string | null;
  note?: string | null;
  offerStatus?: OfferStatus | null;
  parentId?: string | null;
  participants?: ReadonlyArray<ActivityParticipantInput | null> | null;
  pinned?: boolean | null;
  startDate?: string | null;
  subject?: string | null;
  success?: boolean | null;
  visibility?: EmailVisibilityTypeEnum | null;
};
export type ActivityParticipantInput = {
  email?: string | null;
  id?: string | null;
  name?: string | null;
  status?: ParticipantStatus | null;
};
export type FeedItemUpsertActivityMutation$variables = {
  input: UpsertActivityInput;
};
export type FeedItemUpsertActivityMutation$data = {
  readonly upsertActivity: {
    readonly activity: {
      readonly " $fragmentSpreads": FragmentRefs<"FeedItem_activity">;
    } | null;
  } | null;
};
export type FeedItemUpsertActivityMutation = {
  response: FeedItemUpsertActivityMutation$data;
  variables: FeedItemUpsertActivityMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "firstName",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "lastName",
  "storageKey": null
},
v6 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "url",
    "storageKey": null
  },
  (v3/*: any*/)
],
v7 = {
  "alias": null,
  "args": null,
  "concreteType": "Image",
  "kind": "LinkedField",
  "name": "primaryImage",
  "plural": false,
  "selections": (v6/*: any*/),
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "email",
  "storageKey": null
},
v9 = [
  (v8/*: any*/),
  (v3/*: any*/)
],
v10 = {
  "alias": null,
  "args": null,
  "concreteType": "Email",
  "kind": "LinkedField",
  "name": "primaryEmail",
  "plural": false,
  "selections": (v9/*: any*/),
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "referrer",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "concreteType": "Email",
  "kind": "LinkedField",
  "name": "emails",
  "plural": true,
  "selections": (v9/*: any*/),
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "visibility",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "createdAt",
  "storageKey": null
},
v15 = [
  (v3/*: any*/)
],
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
},
v17 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "lotReference",
  "storageKey": null
},
v18 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "salePrice",
  "storageKey": null
},
v19 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "formattedAddress",
  "storageKey": null
},
v20 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "route",
  "storageKey": null
},
v21 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "streetNumber",
  "storageKey": null
},
v22 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "postcode",
  "storageKey": null
},
v23 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "locality",
  "storageKey": null
},
v24 = {
  "alias": null,
  "args": null,
  "concreteType": "PropertyImage",
  "kind": "LinkedField",
  "name": "primaryPropertyImage",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "Image",
      "kind": "LinkedField",
      "name": "image",
      "plural": false,
      "selections": (v6/*: any*/),
      "storageKey": null
    },
    (v3/*: any*/)
  ],
  "storageKey": null
},
v25 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v26 = {
  "alias": null,
  "args": null,
  "concreteType": "Organisation",
  "kind": "LinkedField",
  "name": "organisation",
  "plural": false,
  "selections": [
    (v25/*: any*/),
    (v19/*: any*/),
    (v3/*: any*/)
  ],
  "storageKey": null
},
v27 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "status",
  "storageKey": null
},
v28 = {
  "alias": null,
  "args": null,
  "concreteType": "Subscription",
  "kind": "LinkedField",
  "name": "subscription",
  "plural": false,
  "selections": [
    (v27/*: any*/),
    (v3/*: any*/)
  ],
  "storageKey": null
},
v29 = [
  (v3/*: any*/),
  (v4/*: any*/),
  (v5/*: any*/),
  (v10/*: any*/),
  (v7/*: any*/),
  (v26/*: any*/),
  (v28/*: any*/)
],
v30 = {
  "alias": null,
  "args": null,
  "concreteType": "User",
  "kind": "LinkedField",
  "name": "broker",
  "plural": false,
  "selections": (v29/*: any*/),
  "storageKey": null
},
v31 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "amount",
  "storageKey": null
},
v32 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "currency",
  "storageKey": null
},
v33 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "rentNet",
  "storageKey": null
},
v34 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "rentExtra",
  "storageKey": null
},
v35 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "offerType",
  "storageKey": null
},
v36 = {
  "alias": null,
  "args": null,
  "concreteType": "Enquiry",
  "kind": "LinkedField",
  "name": "enquiries",
  "plural": true,
  "selections": (v15/*: any*/),
  "storageKey": null
},
v37 = {
  "alias": null,
  "args": null,
  "concreteType": "BuyerLead",
  "kind": "LinkedField",
  "name": "matchingBuyerLeads",
  "plural": true,
  "selections": (v15/*: any*/),
  "storageKey": null
},
v38 = [
  (v3/*: any*/),
  (v4/*: any*/),
  (v5/*: any*/),
  (v12/*: any*/)
],
v39 = {
  "alias": null,
  "args": null,
  "concreteType": "User",
  "kind": "LinkedField",
  "name": "user",
  "plural": false,
  "selections": (v38/*: any*/),
  "storageKey": null
},
v40 = [
  (v25/*: any*/),
  (v8/*: any*/),
  (v39/*: any*/)
],
v41 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "countryCode",
  "storageKey": null
},
v42 = [
  (v4/*: any*/),
  (v5/*: any*/),
  (v7/*: any*/),
  (v3/*: any*/)
],
v43 = {
  "alias": null,
  "args": null,
  "concreteType": "User",
  "kind": "LinkedField",
  "name": "seller",
  "plural": false,
  "selections": (v42/*: any*/),
  "storageKey": null
},
v44 = {
  "alias": null,
  "args": null,
  "concreteType": "User",
  "kind": "LinkedField",
  "name": "broker",
  "plural": false,
  "selections": (v42/*: any*/),
  "storageKey": null
},
v45 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "label",
  "storageKey": null
},
v46 = [
  (v25/*: any*/),
  (v3/*: any*/)
],
v47 = {
  "alias": null,
  "args": null,
  "concreteType": "User",
  "kind": "LinkedField",
  "name": "createdBy",
  "plural": false,
  "selections": [
    (v26/*: any*/),
    (v28/*: any*/)
  ],
  "storageKey": null
},
v48 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "note",
  "storageKey": null
},
v49 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "done",
  "storageKey": null
},
v50 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "subject",
  "storageKey": null
},
v51 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "location",
  "storageKey": null
},
v52 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "dueAt",
  "storageKey": null
},
v53 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "startDate",
  "storageKey": null
},
v54 = [
  (v10/*: any*/),
  (v7/*: any*/),
  (v26/*: any*/),
  (v28/*: any*/)
],
v55 = {
  "alias": null,
  "args": null,
  "concreteType": "User",
  "kind": "LinkedField",
  "name": "assignedTo",
  "plural": false,
  "selections": (v54/*: any*/),
  "storageKey": null
},
v56 = {
  "alias": null,
  "args": null,
  "concreteType": "ActivityParticipant",
  "kind": "LinkedField",
  "name": "displayParticipants",
  "plural": true,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "User",
      "kind": "LinkedField",
      "name": "user",
      "plural": false,
      "selections": (v54/*: any*/),
      "storageKey": null
    }
  ],
  "storageKey": null
},
v57 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "success",
  "storageKey": null
},
v58 = {
  "alias": null,
  "args": null,
  "concreteType": "ActivityParticipant",
  "kind": "LinkedField",
  "name": "participants",
  "plural": true,
  "selections": [
    (v25/*: any*/),
    (v8/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "User",
      "kind": "LinkedField",
      "name": "user",
      "plural": false,
      "selections": (v15/*: any*/),
      "storageKey": null
    }
  ],
  "storageKey": null
},
v59 = [
  (v3/*: any*/),
  (v25/*: any*/),
  (v7/*: any*/)
],
v60 = {
  "alias": null,
  "args": null,
  "concreteType": "Lot",
  "kind": "LinkedField",
  "name": "lot",
  "plural": false,
  "selections": (v15/*: any*/),
  "storageKey": null
},
v61 = {
  "alias": null,
  "args": null,
  "concreteType": "Lead",
  "kind": "LinkedField",
  "name": "lead",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "mortgageRevenue",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "mortgageInsuranceRevenue",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "mortgagePurchaseDate",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "mortgageStartDate",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Organisation",
      "kind": "LinkedField",
      "name": "mortgageLender",
      "plural": false,
      "selections": (v59/*: any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Organisation",
      "kind": "LinkedField",
      "name": "mortgageInsuranceProvider",
      "plural": false,
      "selections": (v59/*: any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "mandateProbability",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "predictedListingDate",
      "storageKey": null
    },
    (v60/*: any*/)
  ],
  "storageKey": null
},
v62 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "endDate",
  "storageKey": null
},
v63 = {
  "kind": "InlineFragment",
  "selections": [
    (v62/*: any*/)
  ],
  "type": "ActivityVisit",
  "abstractKey": null
},
v64 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "formattedNumber",
  "storageKey": null
},
v65 = {
  "alias": null,
  "args": null,
  "concreteType": "PhoneNumber",
  "kind": "LinkedField",
  "name": "primaryPhoneNumber",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "number",
      "storageKey": null
    },
    (v64/*: any*/),
    (v3/*: any*/)
  ],
  "storageKey": null
},
v66 = {
  "alias": null,
  "args": null,
  "concreteType": "Lot",
  "kind": "LinkedField",
  "name": "lot",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "Lead",
      "kind": "LinkedField",
      "name": "lead",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "User",
          "kind": "LinkedField",
          "name": "contact",
          "plural": false,
          "selections": [
            (v65/*: any*/),
            (v3/*: any*/)
          ],
          "storageKey": null
        },
        (v3/*: any*/)
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v67 = [
  (v66/*: any*/)
],
v68 = [
  (v65/*: any*/)
],
v69 = {
  "alias": null,
  "args": null,
  "concreteType": "User",
  "kind": "LinkedField",
  "name": "user",
  "plural": false,
  "selections": (v68/*: any*/),
  "storageKey": null
},
v70 = [
  (v25/*: any*/),
  (v8/*: any*/),
  {
    "alias": null,
    "args": null,
    "concreteType": "User",
    "kind": "LinkedField",
    "name": "user",
    "plural": false,
    "selections": [
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v12/*: any*/),
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "gender",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "Email",
        "kind": "LinkedField",
        "name": "primaryEmail",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          (v8/*: any*/)
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "PhoneNumber",
        "kind": "LinkedField",
        "name": "primaryPhoneNumber",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          (v64/*: any*/)
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "Organisation",
        "kind": "LinkedField",
        "name": "organisation",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          (v25/*: any*/),
          (v19/*: any*/)
        ],
        "storageKey": null
      },
      (v16/*: any*/),
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "language",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "FeedItemUpsertActivityMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "UpsertActivityPayload",
        "kind": "LinkedField",
        "name": "upsertActivity",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "activity",
            "plural": false,
            "selections": [
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "FeedItem_activity"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "FeedItemUpsertActivityMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "UpsertActivityPayload",
        "kind": "LinkedField",
        "name": "upsertActivity",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "activity",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "kind": "TypeDiscriminator",
                "abstractKey": "__isActivity"
              },
              (v3/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "User",
                "kind": "LinkedField",
                "name": "createdBy",
                "plural": false,
                "selections": [
                  (v3/*: any*/),
                  (v4/*: any*/),
                  (v5/*: any*/),
                  (v7/*: any*/),
                  (v10/*: any*/),
                  (v11/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "isBroker",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "isAdmin",
                    "storageKey": null
                  },
                  (v12/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "activityType",
                "storageKey": null
              },
              (v13/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "canEditVisibility",
                "storageKey": null
              },
              (v14/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "User",
                "kind": "LinkedField",
                "name": "targetUsers",
                "plural": true,
                "selections": (v15/*: any*/),
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Lot",
                "kind": "LinkedField",
                "name": "lot",
                "plural": false,
                "selections": [
                  (v3/*: any*/),
                  (v16/*: any*/),
                  (v17/*: any*/),
                  (v18/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "mandateType",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "fixedFee",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "commissionRate",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Property",
                    "kind": "LinkedField",
                    "name": "property",
                    "plural": false,
                    "selections": [
                      (v3/*: any*/),
                      (v19/*: any*/),
                      (v20/*: any*/),
                      (v21/*: any*/),
                      (v22/*: any*/),
                      (v23/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v24/*: any*/),
                  (v30/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "User",
                    "kind": "LinkedField",
                    "name": "seller",
                    "plural": false,
                    "selections": (v29/*: any*/),
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Offer",
                    "kind": "LinkedField",
                    "name": "offers",
                    "plural": true,
                    "selections": [
                      (v27/*: any*/),
                      (v31/*: any*/),
                      (v14/*: any*/),
                      (v3/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v2/*: any*/),
                  (v32/*: any*/),
                  (v33/*: any*/),
                  (v34/*: any*/),
                  (v35/*: any*/),
                  (v36/*: any*/),
                  (v37/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "canEdit",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "isOwner",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "pinned",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "ActivityParticipant",
                "kind": "LinkedField",
                "name": "owner",
                "plural": false,
                "selections": (v40/*: any*/),
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "ActivityParticipant",
                "kind": "LinkedField",
                "name": "displayParticipants",
                "plural": true,
                "selections": (v40/*: any*/),
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "User",
                "kind": "LinkedField",
                "name": "assignedTo",
                "plural": false,
                "selections": (v38/*: any*/),
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Enquiry",
                "kind": "LinkedField",
                "name": "enquiry",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  (v3/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "message",
                    "storageKey": null
                  },
                  (v14/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "BuyerLead",
                    "kind": "LinkedField",
                    "name": "buyerLead",
                    "plural": false,
                    "selections": [
                      (v2/*: any*/),
                      (v3/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Portal",
                    "kind": "LinkedField",
                    "name": "portal",
                    "plural": false,
                    "selections": [
                      (v3/*: any*/),
                      (v25/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v39/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Lot",
                    "kind": "LinkedField",
                    "name": "lot",
                    "plural": false,
                    "selections": [
                      (v3/*: any*/),
                      (v24/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Property",
                        "kind": "LinkedField",
                        "name": "property",
                        "plural": false,
                        "selections": [
                          (v20/*: any*/),
                          (v21/*: any*/),
                          (v22/*: any*/),
                          (v23/*: any*/),
                          (v3/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "state",
                            "storageKey": null
                          },
                          (v41/*: any*/)
                        ],
                        "storageKey": null
                      },
                      (v32/*: any*/),
                      (v18/*: any*/),
                      (v33/*: any*/),
                      (v34/*: any*/),
                      (v35/*: any*/),
                      (v43/*: any*/),
                      (v44/*: any*/),
                      (v36/*: any*/),
                      (v37/*: any*/),
                      (v16/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v4/*: any*/),
                  (v5/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Lead",
                "kind": "LinkedField",
                "name": "lead",
                "plural": false,
                "selections": [
                  (v3/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Property",
                    "kind": "LinkedField",
                    "name": "property",
                    "plural": false,
                    "selections": [
                      (v19/*: any*/),
                      (v3/*: any*/),
                      (v41/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "PropertyType",
                        "kind": "LinkedField",
                        "name": "propertyType",
                        "plural": false,
                        "selections": [
                          (v25/*: any*/),
                          (v3/*: any*/),
                          (v45/*: any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "formattedLocality",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "lat",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "lng",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "livingSurface",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "builtSurface",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "landSurface",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "numberOfRooms",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "numberOfBedrooms",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "numberOfResidentialUnits",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "residentialSurface",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "residentialYearlyRentalIncome",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "parkingYearlyRentalIncome",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "numberOfCommercialUnits",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "commercialSurface",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "commercialYearlyRentalIncome",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "incomeIncludesParking",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "plotNumber",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Appraisal",
                        "kind": "LinkedField",
                        "name": "latestAppraisal",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "RealadvisorAppraisal",
                            "kind": "LinkedField",
                            "name": "realadvisor",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "min",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "max",
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          (v3/*: any*/)
                        ],
                        "storageKey": null
                      },
                      (v20/*: any*/),
                      (v21/*: any*/),
                      (v22/*: any*/),
                      (v23/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "User",
                    "kind": "LinkedField",
                    "name": "contact",
                    "plural": false,
                    "selections": [
                      (v3/*: any*/),
                      (v4/*: any*/),
                      (v5/*: any*/),
                      (v10/*: any*/),
                      (v7/*: any*/),
                      (v26/*: any*/),
                      (v28/*: any*/),
                      (v11/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v30/*: any*/),
                  (v2/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "appraisalReason",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "appraisalOpenToOffer",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "appraisalSellingWith",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "appraisalMarketTime",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "appraisalNextStep",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "appraisalMonthlyGrossRent",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "appraisalPerceivedValue",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "appraisalSeparationNextStep",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "appraisalInheritanceNextStep",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "saleHorizon",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "appraisalPerception",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "buyHorizon",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "ownership",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "relationship",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "mortgageTerm",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "mortgageBuyingStatus",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "mortgageStatus",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "receivedMortgageOffer",
                    "storageKey": null
                  },
                  (v14/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "requalifiedAt",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "LeadStage",
                    "kind": "LinkedField",
                    "name": "stage",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Pipeline",
                        "kind": "LinkedField",
                        "name": "pipeline",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "leadType",
                            "storageKey": null
                          },
                          (v3/*: any*/)
                        ],
                        "storageKey": null
                      },
                      (v3/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v11/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "referringDomain",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "landingPageUrl",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "completed",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "userCanViewLeadDetails",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "appraisalPropertyUsage",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "appraisalPropertyOccupied",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "mortgagePropertyValue",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "mortgagePropertyUsage",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "mortgageIsConstruction",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "mortgageMortgageType",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "mortgageReportType",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "MortgageAnalysis",
                    "kind": "LinkedField",
                    "name": "mortgageAnalysis",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "maxPropertyValue",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "GoogleAddress",
                    "kind": "LinkedField",
                    "name": "mortgageGoogleAddress",
                    "plural": false,
                    "selections": [
                      (v19/*: any*/),
                      (v3/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "appraisalPropertyFormattedAddress",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Dictionary",
                    "kind": "LinkedField",
                    "name": "source",
                    "plural": false,
                    "selections": (v46/*: any*/),
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Organisation",
                    "kind": "LinkedField",
                    "name": "sourceOrganisation",
                    "plural": false,
                    "selections": (v46/*: any*/),
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "User",
                    "kind": "LinkedField",
                    "name": "createdBy",
                    "plural": false,
                    "selections": [
                      (v3/*: any*/),
                      (v4/*: any*/),
                      (v5/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "User",
                "kind": "LinkedField",
                "name": "user",
                "plural": false,
                "selections": [
                  (v3/*: any*/),
                  (v4/*: any*/),
                  (v5/*: any*/),
                  (v10/*: any*/),
                  (v7/*: any*/),
                  (v26/*: any*/),
                  (v28/*: any*/),
                  (v2/*: any*/),
                  (v12/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "BuyerLead",
                "kind": "LinkedField",
                "name": "buyerLead",
                "plural": false,
                "selections": [
                  (v3/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "User",
                    "kind": "LinkedField",
                    "name": "user",
                    "plural": false,
                    "selections": [
                      (v4/*: any*/),
                      (v5/*: any*/),
                      (v3/*: any*/),
                      (v10/*: any*/),
                      (v7/*: any*/),
                      (v26/*: any*/),
                      (v28/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Lot",
                    "kind": "LinkedField",
                    "name": "lot",
                    "plural": false,
                    "selections": [
                      (v17/*: any*/),
                      (v16/*: any*/),
                      (v3/*: any*/),
                      (v24/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Property",
                        "kind": "LinkedField",
                        "name": "property",
                        "plural": false,
                        "selections": [
                          (v20/*: any*/),
                          (v21/*: any*/),
                          (v22/*: any*/),
                          (v23/*: any*/),
                          (v3/*: any*/)
                        ],
                        "storageKey": null
                      },
                      (v32/*: any*/),
                      (v18/*: any*/),
                      (v33/*: any*/),
                      (v34/*: any*/),
                      (v35/*: any*/),
                      (v43/*: any*/),
                      (v44/*: any*/),
                      (v36/*: any*/),
                      (v37/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v2/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Offer",
                "kind": "LinkedField",
                "name": "offer",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "User",
                    "kind": "LinkedField",
                    "name": "buyer",
                    "plural": false,
                    "selections": (v38/*: any*/),
                    "storageKey": null
                  },
                  (v3/*: any*/)
                ],
                "storageKey": null
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  (v47/*: any*/),
                  (v48/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ActivityParticipant",
                    "kind": "LinkedField",
                    "name": "participants",
                    "plural": true,
                    "selections": [
                      (v25/*: any*/),
                      (v8/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "User",
                        "kind": "LinkedField",
                        "name": "user",
                        "plural": false,
                        "selections": (v29/*: any*/),
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  (v49/*: any*/)
                ],
                "type": "ActivityNote",
                "abstractKey": null
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  (v48/*: any*/),
                  (v50/*: any*/),
                  (v51/*: any*/),
                  (v52/*: any*/),
                  (v53/*: any*/),
                  (v47/*: any*/),
                  (v55/*: any*/),
                  (v56/*: any*/),
                  (v49/*: any*/),
                  (v57/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v58/*: any*/),
                      (v61/*: any*/),
                      (v63/*: any*/)
                    ],
                    "type": "Activity",
                    "abstractKey": "__isActivity"
                  }
                ],
                "type": "ActivityTask",
                "abstractKey": null
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  (v48/*: any*/),
                  (v50/*: any*/),
                  (v51/*: any*/),
                  (v52/*: any*/),
                  (v53/*: any*/),
                  (v47/*: any*/),
                  (v55/*: any*/),
                  (v56/*: any*/),
                  (v49/*: any*/),
                  (v57/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v58/*: any*/),
                      (v61/*: any*/),
                      (v63/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Enquiry",
                            "kind": "LinkedField",
                            "name": "enquiry",
                            "plural": false,
                            "selections": (v67/*: any*/),
                            "storageKey": null
                          },
                          (v66/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Lead",
                            "kind": "LinkedField",
                            "name": "lead",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "User",
                                "kind": "LinkedField",
                                "name": "contact",
                                "plural": false,
                                "selections": (v68/*: any*/),
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          (v69/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "BuyerLead",
                            "kind": "LinkedField",
                            "name": "buyerLead",
                            "plural": false,
                            "selections": (v67/*: any*/),
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "ActivityParticipant",
                            "kind": "LinkedField",
                            "name": "participants",
                            "plural": true,
                            "selections": [
                              (v69/*: any*/)
                            ],
                            "storageKey": null
                          }
                        ],
                        "type": "ActivityCall",
                        "abstractKey": null
                      }
                    ],
                    "type": "Activity",
                    "abstractKey": "__isActivity"
                  }
                ],
                "type": "ActivityCall",
                "abstractKey": null
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  (v48/*: any*/),
                  (v50/*: any*/),
                  (v51/*: any*/),
                  (v52/*: any*/),
                  (v53/*: any*/),
                  (v62/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "endAt",
                    "storageKey": null
                  },
                  (v47/*: any*/),
                  (v55/*: any*/),
                  (v56/*: any*/),
                  (v49/*: any*/),
                  (v57/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v58/*: any*/),
                      (v61/*: any*/)
                    ],
                    "type": "Activity",
                    "abstractKey": "__isActivity"
                  }
                ],
                "type": "ActivityVisit",
                "abstractKey": null
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "extraData",
                            "storageKey": null
                          }
                        ],
                        "type": "ActivityRequalification",
                        "abstractKey": null
                      }
                    ],
                    "type": "Activity",
                    "abstractKey": "__isActivity"
                  }
                ],
                "type": "ActivityRequalification",
                "abstractKey": null
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  (v49/*: any*/),
                  (v57/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v48/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "doneAt",
                            "storageKey": null
                          },
                          (v52/*: any*/),
                          (v53/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Lead",
                            "kind": "LinkedField",
                            "name": "lead",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "hasOpenActivityForMe",
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "type": "ActivityAssignment",
                        "abstractKey": null
                      }
                    ],
                    "type": "Activity",
                    "abstractKey": "__isActivity"
                  }
                ],
                "type": "ActivityAssignment",
                "abstractKey": null
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  (v49/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "EmailMessage",
                    "kind": "LinkedField",
                    "name": "emailMessage",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "threadId",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "date",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "EmailRecipient",
                        "kind": "LinkedField",
                        "name": "to",
                        "plural": true,
                        "selections": (v70/*: any*/),
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "EmailRecipient",
                        "kind": "LinkedField",
                        "name": "from",
                        "plural": true,
                        "selections": (v70/*: any*/),
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "EmailRecipient",
                        "kind": "LinkedField",
                        "name": "replyTo",
                        "plural": true,
                        "selections": (v70/*: any*/),
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "EmailRecipient",
                        "kind": "LinkedField",
                        "name": "cc",
                        "plural": true,
                        "selections": (v70/*: any*/),
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "EmailRecipient",
                        "kind": "LinkedField",
                        "name": "bcc",
                        "plural": true,
                        "selections": (v70/*: any*/),
                        "storageKey": null
                      },
                      (v3/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "body",
                        "storageKey": null
                      },
                      (v50/*: any*/),
                      (v13/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "messageId",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "isSent",
                        "storageKey": null
                      },
                      (v27/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "snippet",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "EmailMessageFile",
                        "kind": "LinkedField",
                        "name": "emailMessageFiles",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "nylasFileId",
                            "storageKey": null
                          },
                          (v25/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "size",
                            "storageKey": null
                          },
                          (v3/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "type": "ActivityEmail",
                "abstractKey": null
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "offerStatus",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Dictionary",
                    "kind": "LinkedField",
                    "name": "offerRefused",
                    "plural": false,
                    "selections": [
                      (v3/*: any*/),
                      (v45/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Offer",
                            "kind": "LinkedField",
                            "name": "offer",
                            "plural": false,
                            "selections": [
                              (v60/*: any*/),
                              (v31/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "validUntil",
                                "storageKey": null
                              },
                              (v27/*: any*/)
                            ],
                            "storageKey": null
                          }
                        ],
                        "type": "ActivityOffer",
                        "abstractKey": null
                      }
                    ],
                    "type": "Activity",
                    "abstractKey": "__isActivity"
                  }
                ],
                "type": "ActivityOffer",
                "abstractKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "e5c88c7759b321676789dbb67a7e8479",
    "id": null,
    "metadata": {},
    "name": "FeedItemUpsertActivityMutation",
    "operationKind": "mutation",
    "text": "mutation FeedItemUpsertActivityMutation(\n  $input: UpsertActivityInput!\n) {\n  upsertActivity(input: $input) {\n    activity {\n      __typename\n      ...FeedItem_activity\n      id\n    }\n  }\n}\n\nfragment ActivityEventForm_activity on Activity {\n  __isActivity: __typename\n  id\n  visibility\n  canEditVisibility\n  ... on ActivityTask {\n    note\n    subject\n    location\n    dueAt\n    startDate\n    createdBy {\n      id\n      firstName\n      lastName\n      primaryEmail {\n        email\n        id\n      }\n      primaryImage {\n        url\n        id\n      }\n      organisation {\n        name\n        formattedAddress\n        id\n      }\n      subscription {\n        status\n        id\n      }\n    }\n    assignedTo {\n      id\n      firstName\n      lastName\n      primaryEmail {\n        email\n        id\n      }\n      primaryImage {\n        url\n        id\n      }\n      organisation {\n        name\n        formattedAddress\n        id\n      }\n      subscription {\n        status\n        id\n      }\n    }\n    displayParticipants {\n      name\n      email\n      user {\n        id\n        firstName\n        lastName\n        primaryEmail {\n          email\n          id\n        }\n        primaryImage {\n          url\n          id\n        }\n        organisation {\n          name\n          formattedAddress\n          id\n        }\n        subscription {\n          status\n          id\n        }\n      }\n    }\n    owner {\n      email\n    }\n    done\n    success\n  }\n  ... on ActivityCall {\n    note\n    subject\n    location\n    dueAt\n    startDate\n    createdBy {\n      id\n      firstName\n      lastName\n      primaryEmail {\n        email\n        id\n      }\n      primaryImage {\n        url\n        id\n      }\n      organisation {\n        name\n        formattedAddress\n        id\n      }\n      subscription {\n        status\n        id\n      }\n    }\n    assignedTo {\n      id\n      firstName\n      lastName\n      primaryEmail {\n        email\n        id\n      }\n      primaryImage {\n        url\n        id\n      }\n      organisation {\n        name\n        formattedAddress\n        id\n      }\n      subscription {\n        status\n        id\n      }\n    }\n    displayParticipants {\n      name\n      email\n      user {\n        id\n        firstName\n        lastName\n        primaryEmail {\n          email\n          id\n        }\n        primaryImage {\n          url\n          id\n        }\n        organisation {\n          name\n          formattedAddress\n          id\n        }\n        subscription {\n          status\n          id\n        }\n      }\n    }\n    owner {\n      email\n    }\n    done\n    success\n  }\n  ... on ActivityVisit {\n    note\n    subject\n    location\n    dueAt\n    startDate\n    endDate\n    endAt\n    createdBy {\n      id\n      firstName\n      lastName\n      primaryEmail {\n        email\n        id\n      }\n      primaryImage {\n        url\n        id\n      }\n      organisation {\n        name\n        formattedAddress\n        id\n      }\n      subscription {\n        status\n        id\n      }\n    }\n    assignedTo {\n      id\n      firstName\n      lastName\n      primaryEmail {\n        email\n        id\n      }\n      primaryImage {\n        url\n        id\n      }\n      organisation {\n        name\n        formattedAddress\n        id\n      }\n      subscription {\n        status\n        id\n      }\n    }\n    displayParticipants {\n      name\n      email\n      user {\n        id\n        firstName\n        lastName\n        primaryEmail {\n          email\n          id\n        }\n        primaryImage {\n          url\n          id\n        }\n        organisation {\n          name\n          formattedAddress\n          id\n        }\n        subscription {\n          status\n          id\n        }\n      }\n    }\n    owner {\n      email\n    }\n    done\n    success\n  }\n}\n\nfragment ActivityEventForm_buyerLead on BuyerLead {\n  id\n  user {\n    firstName\n    lastName\n    id\n    primaryEmail {\n      email\n      id\n    }\n    primaryImage {\n      url\n      id\n    }\n    organisation {\n      name\n      formattedAddress\n      id\n    }\n    subscription {\n      status\n      id\n    }\n  }\n  lot {\n    lotReference\n    title\n    id\n  }\n  __typename\n}\n\nfragment ActivityEventForm_enquiry on Enquiry {\n  __typename\n  id\n}\n\nfragment ActivityEventForm_lead on Lead {\n  id\n  property {\n    formattedAddress\n    id\n  }\n  contact {\n    id\n    firstName\n    lastName\n    primaryEmail {\n      email\n      id\n    }\n    primaryImage {\n      url\n      id\n    }\n    organisation {\n      name\n      formattedAddress\n      id\n    }\n    subscription {\n      status\n      id\n    }\n  }\n  broker {\n    id\n    firstName\n    lastName\n    primaryEmail {\n      email\n      id\n    }\n    primaryImage {\n      url\n      id\n    }\n    organisation {\n      name\n      formattedAddress\n      id\n    }\n    subscription {\n      status\n      id\n    }\n  }\n  __typename\n}\n\nfragment ActivityEventForm_lot on Lot {\n  id\n  title\n  lotReference\n  salePrice\n  mandateType\n  fixedFee\n  commissionRate\n  property {\n    id\n    formattedAddress\n  }\n  primaryPropertyImage {\n    image {\n      url\n      id\n    }\n    id\n  }\n  broker {\n    id\n    firstName\n    lastName\n    primaryEmail {\n      email\n      id\n    }\n    primaryImage {\n      url\n      id\n    }\n    organisation {\n      name\n      formattedAddress\n      id\n    }\n    subscription {\n      status\n      id\n    }\n  }\n  seller {\n    id\n    firstName\n    lastName\n    primaryEmail {\n      email\n      id\n    }\n    primaryImage {\n      url\n      id\n    }\n    organisation {\n      name\n      formattedAddress\n      id\n    }\n    subscription {\n      status\n      id\n    }\n  }\n  offers {\n    status\n    amount\n    createdAt\n    id\n  }\n  __typename\n}\n\nfragment ActivityEventForm_user on User {\n  id\n  firstName\n  lastName\n  primaryEmail {\n    email\n    id\n  }\n  primaryImage {\n    url\n    id\n  }\n  organisation {\n    name\n    formattedAddress\n    id\n  }\n  subscription {\n    status\n    id\n  }\n  __typename\n}\n\nfragment ActivityForm_activity on Activity {\n  __isActivity: __typename\n  activityType\n  ...ActivityNoteForm_activity\n  ...ActivityEventForm_activity\n}\n\nfragment ActivityForm_buyerLead on BuyerLead {\n  ...ActivityNoteForm_buyerLead\n  ...ActivityEventForm_buyerLead\n}\n\nfragment ActivityForm_enquiry on Enquiry {\n  ...ActivityNoteForm_enquiry\n  ...ActivityEventForm_enquiry\n}\n\nfragment ActivityForm_lead on Lead {\n  ...ActivityNoteForm_lead\n  ...ActivityEventForm_lead\n}\n\nfragment ActivityForm_lot on Lot {\n  ...ActivityNoteForm_lot\n  ...ActivityEventForm_lot\n}\n\nfragment ActivityForm_user on User {\n  ...ActivityNoteForm_user\n  ...ActivityEventForm_user\n}\n\nfragment ActivityNoteForm_activity on Activity {\n  __isActivity: __typename\n  id\n  ... on ActivityNote {\n    createdBy {\n      id\n      firstName\n      lastName\n      primaryEmail {\n        email\n        id\n      }\n      primaryImage {\n        url\n        id\n      }\n      organisation {\n        name\n        formattedAddress\n        id\n      }\n      subscription {\n        status\n        id\n      }\n    }\n    visibility\n    note\n    participants {\n      name\n      email\n      user {\n        id\n        firstName\n        lastName\n        primaryEmail {\n          email\n          id\n        }\n        primaryImage {\n          url\n          id\n        }\n        organisation {\n          name\n          formattedAddress\n          id\n        }\n        subscription {\n          status\n          id\n        }\n      }\n    }\n  }\n}\n\nfragment ActivityNoteForm_buyerLead on BuyerLead {\n  id\n  user {\n    firstName\n    lastName\n    id\n    primaryEmail {\n      email\n      id\n    }\n    primaryImage {\n      url\n      id\n    }\n    organisation {\n      name\n      formattedAddress\n      id\n    }\n    subscription {\n      status\n      id\n    }\n  }\n  lot {\n    lotReference\n    title\n    id\n  }\n  __typename\n}\n\nfragment ActivityNoteForm_enquiry on Enquiry {\n  __typename\n  id\n}\n\nfragment ActivityNoteForm_lead on Lead {\n  id\n  property {\n    formattedAddress\n    id\n  }\n  contact {\n    id\n    firstName\n    lastName\n    primaryEmail {\n      email\n      id\n    }\n    primaryImage {\n      url\n      id\n    }\n    organisation {\n      name\n      formattedAddress\n      id\n    }\n    subscription {\n      status\n      id\n    }\n  }\n  broker {\n    id\n    firstName\n    lastName\n    primaryEmail {\n      email\n      id\n    }\n    primaryImage {\n      url\n      id\n    }\n    organisation {\n      name\n      formattedAddress\n      id\n    }\n    subscription {\n      status\n      id\n    }\n  }\n  __typename\n}\n\nfragment ActivityNoteForm_lot on Lot {\n  id\n  title\n  lotReference\n  salePrice\n  mandateType\n  fixedFee\n  commissionRate\n  property {\n    id\n    formattedAddress\n  }\n  primaryPropertyImage {\n    image {\n      url\n      id\n    }\n    id\n  }\n  broker {\n    id\n    firstName\n    lastName\n    primaryEmail {\n      email\n      id\n    }\n    primaryImage {\n      url\n      id\n    }\n    organisation {\n      name\n      formattedAddress\n      id\n    }\n    subscription {\n      status\n      id\n    }\n  }\n  seller {\n    id\n    firstName\n    lastName\n    primaryEmail {\n      email\n      id\n    }\n    primaryImage {\n      url\n      id\n    }\n    organisation {\n      name\n      formattedAddress\n      id\n    }\n    subscription {\n      status\n      id\n    }\n  }\n  offers {\n    status\n    amount\n    createdAt\n    id\n  }\n  __typename\n}\n\nfragment ActivityNoteForm_user on User {\n  id\n  firstName\n  lastName\n  primaryEmail {\n    email\n    id\n  }\n  primaryImage {\n    url\n    id\n  }\n  organisation {\n    name\n    formattedAddress\n    id\n  }\n  subscription {\n    status\n    id\n  }\n  __typename\n}\n\nfragment ConnectEmailForm_forwardMessage on EmailMessage {\n  ...EmailForm_forwardMessage\n}\n\nfragment ConnectEmailForm_replyToMessage on EmailMessage {\n  ...EmailForm_replyToMessage\n}\n\nfragment EmailForm_forwardMessage on EmailMessage {\n  id\n  date\n  body\n  subject\n  visibility\n  from {\n    name\n    email\n    user {\n      id\n      firstName\n      lastName\n      gender\n      primaryEmail {\n        id\n        email\n      }\n      primaryPhoneNumber {\n        id\n        formattedNumber\n      }\n      organisation {\n        id\n        name\n        formattedAddress\n      }\n      title\n      language\n    }\n  }\n  to {\n    name\n    email\n    user {\n      id\n      firstName\n      lastName\n      gender\n      primaryEmail {\n        id\n        email\n      }\n      primaryPhoneNumber {\n        id\n        formattedNumber\n      }\n      organisation {\n        id\n        name\n        formattedAddress\n      }\n      title\n      language\n    }\n  }\n  cc {\n    name\n    email\n    user {\n      id\n      firstName\n      lastName\n      gender\n      primaryEmail {\n        id\n        email\n      }\n      primaryPhoneNumber {\n        id\n        formattedNumber\n      }\n      organisation {\n        id\n        name\n        formattedAddress\n      }\n      title\n      language\n    }\n  }\n  bcc {\n    name\n    email\n    user {\n      id\n      firstName\n      lastName\n      gender\n      primaryEmail {\n        id\n        email\n      }\n      primaryPhoneNumber {\n        id\n        formattedNumber\n      }\n      organisation {\n        id\n        name\n        formattedAddress\n      }\n      title\n      language\n    }\n  }\n  replyTo {\n    name\n    email\n    user {\n      id\n      firstName\n      lastName\n      gender\n      primaryEmail {\n        id\n        email\n      }\n      primaryPhoneNumber {\n        id\n        formattedNumber\n      }\n      organisation {\n        id\n        name\n        formattedAddress\n      }\n      title\n      language\n    }\n  }\n  messageId\n  isSent\n}\n\nfragment EmailForm_replyToMessage on EmailMessage {\n  id\n  date\n  body\n  subject\n  visibility\n  from {\n    name\n    email\n    user {\n      id\n      firstName\n      lastName\n      gender\n      primaryEmail {\n        id\n        email\n      }\n      primaryPhoneNumber {\n        id\n        formattedNumber\n      }\n      organisation {\n        id\n        name\n        formattedAddress\n      }\n      title\n      language\n    }\n  }\n  to {\n    name\n    email\n    user {\n      id\n      firstName\n      lastName\n      gender\n      primaryEmail {\n        id\n        email\n      }\n      primaryPhoneNumber {\n        id\n        formattedNumber\n      }\n      organisation {\n        id\n        name\n        formattedAddress\n      }\n      title\n      language\n    }\n  }\n  cc {\n    name\n    email\n    user {\n      id\n      firstName\n      lastName\n      gender\n      primaryEmail {\n        id\n        email\n      }\n      primaryPhoneNumber {\n        id\n        formattedNumber\n      }\n      organisation {\n        id\n        name\n        formattedAddress\n      }\n      title\n      language\n    }\n  }\n  bcc {\n    name\n    email\n    user {\n      id\n      firstName\n      lastName\n      gender\n      primaryEmail {\n        id\n        email\n      }\n      primaryPhoneNumber {\n        id\n        formattedNumber\n      }\n      organisation {\n        id\n        name\n        formattedAddress\n      }\n      title\n      language\n    }\n  }\n  replyTo {\n    name\n    email\n    user {\n      id\n      firstName\n      lastName\n      gender\n      primaryEmail {\n        id\n        email\n      }\n      primaryPhoneNumber {\n        id\n        formattedNumber\n      }\n      organisation {\n        id\n        name\n        formattedAddress\n      }\n      title\n      language\n    }\n  }\n  messageId\n  isSent\n}\n\nfragment FeedAssignmentClaimLead on Activity {\n  __isActivity: __typename\n  id\n  assignedTo {\n    id\n  }\n  ... on ActivityAssignment {\n    lead {\n      id\n      hasOpenActivityForMe\n    }\n  }\n}\n\nfragment FeedAssignment_activity on Activity {\n  __isActivity: __typename\n  id\n  ... on ActivityAssignment {\n    ...FeedAssignmentClaimLead\n    canEdit\n    success\n    assignedTo {\n      ...UserName_user\n      id\n    }\n    note\n    done\n    doneAt\n    dueAt\n    startDate\n    lead {\n      id\n      hasOpenActivityForMe\n      completed\n    }\n  }\n}\n\nfragment FeedCall_activity on Activity {\n  __isActivity: __typename\n  ...activityWorkflowDialog_activity\n  id\n  ... on ActivityCall {\n    canEdit\n    done\n    dueAt\n    startDate\n    success\n    note\n    enquiry {\n      __typename\n      id\n      lot {\n        lead {\n          contact {\n            primaryPhoneNumber {\n              number\n              formattedNumber\n              id\n            }\n            id\n          }\n          id\n        }\n        id\n      }\n    }\n    lot {\n      __typename\n      id\n      lead {\n        contact {\n          primaryPhoneNumber {\n            number\n            formattedNumber\n            id\n          }\n          id\n        }\n        id\n      }\n    }\n    lead {\n      __typename\n      id\n      stage {\n        pipeline {\n          leadType\n          id\n        }\n        id\n      }\n      contact {\n        primaryPhoneNumber {\n          number\n          formattedNumber\n          id\n        }\n        id\n      }\n    }\n    user {\n      __typename\n      id\n      primaryPhoneNumber {\n        number\n        formattedNumber\n        id\n      }\n    }\n    buyerLead {\n      __typename\n      id\n      lot {\n        lead {\n          contact {\n            primaryPhoneNumber {\n              number\n              formattedNumber\n              id\n            }\n            id\n          }\n          id\n        }\n        id\n      }\n    }\n    participants {\n      user {\n        primaryPhoneNumber {\n          number\n          formattedNumber\n          id\n        }\n        id\n      }\n    }\n  }\n}\n\nfragment FeedDeleteDialog_activity on Activity {\n  __isActivity: __typename\n  id\n  createdBy {\n    ...userAvatar_user\n    id\n  }\n}\n\nfragment FeedEmail_activity on ActivityEmail {\n  id\n  emailMessage {\n    ...ConnectEmailForm_replyToMessage\n    ...ConnectEmailForm_forwardMessage\n    id\n    subject\n    status\n    snippet\n    to {\n      name\n      user {\n        id\n      }\n    }\n    from {\n      name\n      user {\n        id\n      }\n    }\n    cc {\n      name\n      user {\n        id\n      }\n    }\n    bcc {\n      name\n      user {\n        id\n      }\n    }\n    emailMessageFiles {\n      nylasFileId\n      name\n      size\n      id\n    }\n  }\n}\n\nfragment FeedItem_activity on Activity {\n  __isActivity: __typename\n  ...FeedDeleteDialog_activity\n  ...ActivityForm_activity\n  ...NewMatch_activity\n  __typename\n  id\n  createdAt\n  activityType\n  canEdit\n  canEditVisibility\n  isOwner\n  visibility\n  pinned\n  createdBy {\n    id\n    ...UserName_user\n  }\n  owner {\n    name\n    email\n    user {\n      id\n      ...UserName_user\n    }\n  }\n  displayParticipants {\n    name\n    email\n    user {\n      id\n      ...UserName_user\n    }\n  }\n  assignedTo {\n    id\n    ...UserName_user\n  }\n  enquiry {\n    ...ActivityForm_enquiry\n    ...parentLink_enquiry\n    ...feedEnquiry_parent\n    id\n    portal {\n      id\n      name\n    }\n    user {\n      ...UserName_user\n      id\n    }\n    lot {\n      ...lotSnippet_lot\n      id\n      title\n      property {\n        route\n        streetNumber\n        postcode\n        locality\n        state\n        countryCode\n        id\n      }\n    }\n    firstName\n    lastName\n  }\n  lot {\n    ...ActivityForm_lot\n    ...parentLink_lot\n    ...lotSnippet_lot\n    id\n    title\n  }\n  lead {\n    ...ActivityForm_lead\n    ...parentLink_lead\n    ...leadSnippet_lead\n    source {\n      name\n      id\n    }\n    userCanViewLeadDetails\n    sourceOrganisation {\n      name\n      id\n    }\n    property {\n      route\n      streetNumber\n      postcode\n      locality\n      id\n    }\n    createdBy {\n      id\n      firstName\n      lastName\n    }\n    id\n  }\n  user {\n    ...ActivityForm_user\n    ...parentLink_user\n    id\n    firstName\n    lastName\n  }\n  buyerLead {\n    ...ActivityForm_buyerLead\n    ...parentLink_buyerLead\n    id\n    lot {\n      ...lotSnippet_lot\n      id\n    }\n    user {\n      firstName\n      lastName\n      id\n    }\n  }\n  offer {\n    buyer {\n      id\n      ...UserName_user\n    }\n    id\n  }\n  ... on ActivityRequalification {\n    ...FeedRequalification_activity\n  }\n  ... on ActivityCall {\n    ...FeedCall_activity\n    done\n    success\n  }\n  ... on ActivityVisit {\n    ...FeedVisit_activity\n    done\n    success\n  }\n  ... on ActivityNote {\n    done\n    ...FeedNote_activity\n  }\n  ... on ActivityTask {\n    done\n    success\n    ...FeedTask_activity\n  }\n  ... on ActivityCreateUser {\n    __typename\n  }\n  ... on ActivityAssignment {\n    done\n    success\n    ...FeedAssignment_activity\n  }\n  ... on ActivityEmail {\n    done\n    emailMessage {\n      threadId\n      date\n      to {\n        name\n        email\n        user {\n          id\n          ...UserName_user\n        }\n      }\n      from {\n        name\n        email\n        user {\n          id\n          ...UserName_user\n        }\n      }\n      replyTo {\n        name\n        email\n        user {\n          id\n          ...UserName_user\n        }\n      }\n      cc {\n        name\n        email\n        user {\n          id\n          ...UserName_user\n        }\n      }\n      bcc {\n        name\n        email\n        user {\n          id\n          ...UserName_user\n        }\n      }\n      id\n    }\n    ...FeedEmail_activity\n  }\n  ... on ActivityOffer {\n    offerStatus\n    offerRefused {\n      id\n      label\n    }\n    ...feedOffer_activity\n  }\n}\n\nfragment FeedNote_activity on Activity {\n  __isActivity: __typename\n  ... on ActivityNote {\n    note\n  }\n}\n\nfragment FeedRequalification_activity on Activity {\n  __isActivity: __typename\n  ... on ActivityRequalification {\n    extraData\n  }\n}\n\nfragment FeedTask_activity on Activity {\n  __isActivity: __typename\n  ...activityWorkflowDialog_activity\n  id\n  ... on ActivityTask {\n    canEdit\n    note\n    subject\n    dueAt\n    startDate\n    done\n    enquiry {\n      __typename\n      id\n    }\n    lot {\n      __typename\n      id\n    }\n    lead {\n      __typename\n      id\n      stage {\n        pipeline {\n          leadType\n          id\n        }\n        id\n      }\n    }\n    user {\n      __typename\n      id\n    }\n    buyerLead {\n      __typename\n      id\n    }\n  }\n}\n\nfragment FeedVisit_activity on Activity {\n  __isActivity: __typename\n  ...activityWorkflowDialog_activity\n  id\n  ... on ActivityVisit {\n    canEdit\n    done\n    dueAt\n    startDate\n    note\n    location\n    enquiry {\n      __typename\n      id\n    }\n    lot {\n      __typename\n      id\n    }\n    lead {\n      __typename\n      id\n      stage {\n        pipeline {\n          leadType\n          id\n        }\n        id\n      }\n    }\n    user {\n      __typename\n      id\n    }\n    buyerLead {\n      __typename\n      id\n    }\n  }\n}\n\nfragment NewMatch_activity on Activity {\n  __isActivity: __typename\n  createdAt\n  targetUsers {\n    id\n  }\n  lot {\n    id\n  }\n}\n\nfragment UserName_user on User {\n  id\n  firstName\n  lastName\n  emails {\n    email\n    id\n  }\n}\n\nfragment activityWorkflowDialog_activity on Activity {\n  __isActivity: __typename\n  id\n  visibility\n  ... on ActivityVisit {\n    location\n    startDate\n    endDate\n    note\n  }\n  ... on ActivityCall {\n    note\n  }\n  ... on ActivityTask {\n    note\n  }\n  ... on ActivityNote {\n    note\n  }\n  assignedTo {\n    id\n    firstName\n    lastName\n    primaryEmail {\n      email\n      id\n    }\n    primaryImage {\n      url\n      id\n    }\n    organisation {\n      name\n      formattedAddress\n      id\n    }\n    subscription {\n      status\n      id\n    }\n  }\n  createdBy {\n    id\n    firstName\n    lastName\n    primaryEmail {\n      email\n      id\n    }\n    primaryImage {\n      url\n      id\n    }\n    organisation {\n      name\n      formattedAddress\n      id\n    }\n    subscription {\n      status\n      id\n    }\n  }\n  displayParticipants {\n    name\n    email\n    user {\n      id\n      firstName\n      lastName\n      primaryEmail {\n        email\n        id\n      }\n      primaryImage {\n        url\n        id\n      }\n      organisation {\n        name\n        formattedAddress\n        id\n      }\n      subscription {\n        status\n        id\n      }\n    }\n  }\n  participants {\n    name\n    email\n    user {\n      id\n    }\n  }\n  enquiry {\n    id\n  }\n  lot {\n    id\n    property {\n      formattedAddress\n      id\n    }\n  }\n  lead {\n    ...financingWonDialog_lead\n    id\n    property {\n      formattedAddress\n      id\n    }\n    mandateProbability\n    predictedListingDate\n    stage {\n      id\n    }\n    lot {\n      id\n    }\n  }\n  user {\n    id\n  }\n  buyerLead {\n    id\n  }\n}\n\nfragment feedEnquiry_parent on Enquiry {\n  id\n  message\n  createdAt\n  buyerLead {\n    __typename\n    id\n  }\n}\n\nfragment feedOffer_activity on Activity {\n  __isActivity: __typename\n  id\n  ... on ActivityOffer {\n    offer {\n      id\n      lot {\n        id\n      }\n      amount\n      validUntil\n      status\n    }\n  }\n}\n\nfragment financingWonDialog_lead on Lead {\n  id\n  mortgageRevenue\n  mortgagePropertyValue\n  mortgageInsuranceRevenue\n  mortgagePurchaseDate\n  mortgageStartDate\n  mortgageLender {\n    id\n    name\n    primaryImage {\n      url\n      id\n    }\n  }\n  mortgageInsuranceProvider {\n    id\n    name\n    primaryImage {\n      url\n      id\n    }\n  }\n}\n\nfragment leadQualificationFunnel_lead on Lead {\n  appraisalReason\n  appraisalOpenToOffer\n  appraisalSellingWith\n  appraisalMarketTime\n  appraisalNextStep\n  appraisalMonthlyGrossRent\n  appraisalPerceivedValue\n  appraisalSeparationNextStep\n  appraisalInheritanceNextStep\n  saleHorizon\n  appraisalPerception\n  buyHorizon\n  ownership\n  relationship\n  mortgageTerm\n  mortgageBuyingStatus\n  mortgageStatus\n  receivedMortgageOffer\n  property {\n    countryCode\n    propertyType {\n      name\n      id\n    }\n    id\n  }\n}\n\nfragment leadSnippet_lead on Lead {\n  ...leadQualificationFunnel_lead\n  ...leadUpdatedTimeAgo_lead\n  id\n  stage {\n    pipeline {\n      leadType\n      id\n    }\n    id\n  }\n  referrer\n  referringDomain\n  landingPageUrl\n  completed\n  userCanViewLeadDetails\n  appraisalPerceivedValue\n  appraisalPerception\n  appraisalPropertyUsage\n  relationship\n  appraisalPropertyOccupied\n  mortgagePropertyValue\n  mortgagePropertyUsage\n  mortgageIsConstruction\n  mortgageMortgageType\n  mortgageReportType\n  mortgageAnalysis {\n    maxPropertyValue\n  }\n  mortgageGoogleAddress {\n    formattedAddress\n    id\n  }\n  appraisalPropertyFormattedAddress\n  property {\n    countryCode\n    formattedAddress\n    formattedLocality\n    lat\n    lng\n    livingSurface\n    builtSurface\n    landSurface\n    numberOfRooms\n    numberOfBedrooms\n    numberOfResidentialUnits\n    residentialSurface\n    residentialYearlyRentalIncome\n    parkingYearlyRentalIncome\n    numberOfCommercialUnits\n    commercialSurface\n    commercialYearlyRentalIncome\n    incomeIncludesParking\n    plotNumber\n    propertyType {\n      label\n      name\n      id\n    }\n    latestAppraisal {\n      realadvisor {\n        min\n        max\n      }\n      id\n    }\n    id\n  }\n  contact {\n    firstName\n    lastName\n    referrer\n    id\n  }\n}\n\nfragment leadUpdatedTimeAgo_lead on Lead {\n  createdAt\n  requalifiedAt\n}\n\nfragment lotSnippet_lot on Lot {\n  id\n  primaryPropertyImage {\n    image {\n      url\n      id\n    }\n    id\n  }\n  property {\n    route\n    streetNumber\n    postcode\n    locality\n    id\n  }\n  currency\n  salePrice\n  rentNet\n  rentExtra\n  offerType\n  seller {\n    firstName\n    lastName\n    primaryImage {\n      url\n      id\n    }\n    id\n  }\n  broker {\n    firstName\n    lastName\n    primaryImage {\n      url\n      id\n    }\n    id\n  }\n  enquiries {\n    id\n  }\n  matchingBuyerLeads {\n    id\n  }\n}\n\nfragment parentLink_buyerLead on BuyerLead {\n  id\n  lot {\n    id\n  }\n}\n\nfragment parentLink_enquiry on Enquiry {\n  id\n}\n\nfragment parentLink_lead on Lead {\n  id\n}\n\nfragment parentLink_lot on Lot {\n  id\n}\n\nfragment parentLink_user on User {\n  ...UserName_user\n  id\n}\n\nfragment userAvatar_user on User {\n  id\n  firstName\n  lastName\n  primaryImage {\n    url\n    id\n  }\n  primaryEmail {\n    email\n    id\n  }\n  referrer\n  isBroker\n  isAdmin\n}\n"
  }
};
})();

(node as any).hash = "f544e9826b337ecad3b46cca018bd775";

export default node;
